import { render, staticRenderFns } from "./FilesContainerNew.vue?vue&type=template&id=41fb12f0&scoped=true"
import script from "./FilesContainerNew.vue?vue&type=script&lang=js"
export * from "./FilesContainerNew.vue?vue&type=script&lang=js"
import style0 from "./FilesContainerNew.vue?vue&type=style&index=0&id=41fb12f0&prod&lang=css"
import style1 from "./FilesContainerNew.vue?vue&type=style&index=1&id=41fb12f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fb12f0",
  null
  
)

export default component.exports